<div class="step-final">
  <div *ngIf="actions" class="amounts-table">
    <p>
      <label>{{ 'PARTNER.WIZARD.SUB_FINAL_STEP.AMOUNT' | translate }}</label>
      <span>€{{transaction.final_amount}}</span>
    </p>
    <p *ngIf="actions.redeem=='1'">
      <label>{{ 'PARTNER.WIZARD.SUB_FINAL_STEP.DISCOUNT_AMOUNT' | translate }}</label>
      <span>€{{transaction.discount_amount}}</span>
    </p>
    <p *ngIf="actions.redeem=='1'">
      <label>{{ 'PARTNER.WIZARD.SUB_FINAL_STEP.POINTS_TO_REDEEM' | translate }}</label>
      <span>{{transaction.discount_points}}</span>
    </p>
    <p>
      <label>{{ 'PARTNER.WIZARD.SUB_FINAL_STEP.POINTS_ADDED' | translate }}</label>
      <span>{{transaction.added_points}}</span>
    </p>
    <p>
      <label>{{ 'PARTNER.WIZARD.SUB_FINAL_STEP.POINTS_REMAINING' | translate }}</label>
      <span>{{transaction.final_points}}</span>
    </p>
  </div>

  <!--begin::Wizard Buttons-->
  <button class="btn btn-primary" (click)="onNextStep()">
    {{ 'PARTNER.WIZARD.CLOSE' | translate }}
  </button>
  <!--end::Wizard Buttons-->

</div>